var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.991 16.111C16.9321 17.1708 16.0556 18 14.9941 18H2.7779C1.71639 18 0.839808 17.1708 0.780928 16.111L0.00314294 2.11095C-0.0605478 0.964535 0.851904 0 2.00009 0H15.7719C16.9201 0 17.8325 0.96454 17.7688 2.11095L16.991 16.111ZM14.0081 5.8893C14.418 5.61925 14.5211 5.08385 14.1847 4.7355C13.6225 4.1533 12.9555 3.66525 12.2122 3.29475C11.2012 2.79085 10.0774 2.51885 8.93292 2.50095C7.78846 2.48305 6.6557 2.7198 5.62733 3.19185C4.87127 3.5389 4.18741 4.00585 3.60486 4.57015C3.25625 4.9078 3.34035 5.4461 3.74051 5.72885L5.89649 7.2521C6.29664 7.5348 6.8603 7.4434 7.2749 7.1797C7.38105 7.1122 7.49241 7.0516 7.60821 6.99845C7.97381 6.8306 8.37427 6.74145 8.78052 6.73705L10.477 4.78645C10.6582 4.5781 10.974 4.5561 11.1825 4.7373C11.3908 4.9185 11.4128 5.23435 11.2316 5.4427L9.91639 6.9549C9.97774 6.98025 10.0382 7.00775 10.0976 7.03735C10.2114 7.0941 10.3206 7.15815 10.4243 7.22895C10.8293 7.5054 11.3894 7.6144 11.7994 7.34435L14.0081 5.8893Z",
    fill: "#161B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/Weight.74aa488dd25b5c74b9c6f436a7c36e36.svg";
export { ForwardRef as ReactComponent };